import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-logout-all-session',
  template: `
    <div style="min-height:70vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px">
      <mat-spinner diameter="48"></mat-spinner>
      <p>Signing you out, please wait…</p>
    </div>`,
})
export class LogoutAllSessionComponent implements OnInit {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.auth.clearSession();
    this.router.navigateByUrl('/auth/login');
  }
}
